import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { Skeleton as ShadcnSkeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/ui/utils';

// Morfi customizations layered over stock skeleton.tsx:
//  - animate-shimmer (overrides stock's animate-pulse via tailwind-merge — both
//    target the `animation` property, last-wins. Defined in globals.css via
//    `--animate-shimmer` in @theme.)
//  - skeleton-shimmer (gradient background-image overlay that the animation
//    sweeps across)
//  - motion-reduce:animate-none (accessibility — also kills the shimmer
//    animation under prefers-reduced-motion)
//  - bg-background-tertiary (Morfi surface token; the shimmer gradient is a
//    background-image so the base color shows through)
//  - rounded-item (overrides stock's rounded-md so default Skeletons match
//    other small markers). Consumer className still wins via tailwind-merge
//    in cn() — pass `rounded-full` etc. as needed.
const SKELETON_MORFI_TOKENS = 'motion-reduce:animate-none rounded-item bg-background-tertiary skeleton-shimmer animate-shimmer' as const;
export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;
export function Skeleton(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn(SKELETON_MORFI_TOKENS, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ShadcnSkeleton className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}